import React from 'react';

import {PopupFullPage} from '@/components/Popup';
import TipsAndTutorials from '@/views/TipsAndTutorials/TipsAndTutorials';

const QuickStartGuideMobile = ({onClose}) => {
    return (
        <PopupFullPage
            className='flex h-full'
            // TODO: add headerId
            // aria-labelledby={headerId}
            onClose={onClose}
        >
            <TipsAndTutorials isQuickStartGuide onBack={onClose} skipFirstStep />
        </PopupFullPage>
    );
};

export default QuickStartGuideMobile;
